var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { "no-activity": !_vm.activityImgDetail.status },
      attrs: { id: "page_Container" }
    },
    [
      _vm.activityImgDetail.status
        ? _c("div", { staticClass: "page", attrs: { id: "activity-page" } }, [
            _c(
              "div",
              {
                staticClass: "main-container",
                attrs: { id: "main-container" }
              },
              _vm._l(_vm.curMap, function(curMapItem) {
                return _c(
                  "div",
                  { key: curMapItem.id, staticClass: "map-div" },
                  [
                    _c("img", {
                      staticClass: "imgContent",
                      attrs: {
                        src: curMapItem.img[0].photoUrl,
                        draggable: "false",
                        usemap: "#Map" + curMapItem.id
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "map",
                      { attrs: { name: "#Map" + curMapItem.id } },
                      _vm._l(curMapItem.area, function(item, i) {
                        return _c("area", {
                          key: i,
                          attrs: { shape: item.rect, coords: item.coords },
                          on: {
                            click: function($event) {
                              _vm.openOtherPage(item.href)
                            }
                          }
                        })
                      }),
                      0
                    )
                  ]
                )
              }),
              0
            )
          ])
        : _c("div", { staticClass: "no-activity" }, [
            _c("img", {
              attrs: {
                src: require("../assets/img/myCenter/noActivity.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("div", [_vm._v("活动已结束")])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }